// extracted by mini-css-extract-plugin
module.exports = {"successText":"device-log_successText_3iduZ","errorText":"device-log_errorText_2wXSu"};